<template>
<div class="contact">
    <publicHead :background="bg" title="联系我们" en-title="CONTACT US"></publicHead>
    <div class="wrap">
        <p class="child-title">联系我们</p>
        <p class="child-sub-title">CONTACT US</p>
        <div>
            <div>
                <img src="../assets/img/Shape.png" alt srcset />
                <span>电话</span>
                <img src="../assets/img/hr.png" class="hr" srcset />
                <span>{{detail.tel}}</span>
            </div>
            <div>
                <img src="../assets/img/Mail1.png" alt srcset />
                <span>邮箱</span>
                <img src="../assets/img/hr.png" class="hr" srcset />
                <span>{{detail.yx}}</span>
            </div>
            <div>
                <img src="../assets/img/Print.png" alt srcset />
                <span>传真</span>
                <img src="../assets/img/hr.png" class="hr" srcset />
                <span>{{detail.cz}}</span>
            </div>
            <div>
                <img src="../assets/img/Location.png" alt srcset />
                <span>地址</span>
                <img src="../assets/img/hr.png" class="hr" srcset />
                <span>{{detail.address}}</span>
            </div>
        </div>
    </div>
    <baidu-map :center="center" :zoom="15" id="map" class="baidu-map-view" ak="YhllasINn7Y0zyEGLyXmBGx47AVBwAxM" :marker="center" scroll-wheel-zoom>
        <bm-marker key="marker.code" :position="center">
            <bm-info-window :position="center" :show="true">
                <div class="wrapper">
                    <img src="../assets/img/logo2.png" alt srcset />
                </div>
            </bm-info-window>
        </bm-marker>
    </baidu-map>
</div>
</template>

<script>
import {
    BaiduMap,
    BmScale,
    BmGeolocation,
    BmNavigation,
    BmMarkerClusterer,
    BmMarker,
    BmInfoWindow,
    BmTransit,
    BmOverlay,
} from "vue-baidu-map";
import {
    pz
} from "../assets/js/api";
export default {
    components: {
        BaiduMap,
        BmMarker,
        BmMarkerClusterer,
        BmScale,
        BmNavigation,
        BmInfoWindow,
        BmTransit,
        BmOverlay,
    },
    data() {
        return {
            center: {
                lng: 109.45744048529967,
                lat: 36.49771311230842,
            },
            detail: {},
            bg: require("../assets/img/contact-head.png"),
        };
    },
    created() {
        pz().then((r) => {
            this.detail = r.data;
            this.center.lng = r.data.x;
            this.center.lat = r.data.y;
        });
    },
    methods: {
        draw({
            el,
            BMap,
            map
        }) {
            const pixel = map.pointToOverlayPixel(new BMap.Point(this.center));
            el.style.position = "absolute";
            el.style.left = pixel.x - 6 + "px";
            el.style.top = pixel.y + "px";
        },
    },
};
</script>

<style lang="less" scoped>
.wrap {
    padding: 0 0.3rem;
    padding-top: 0.73rem;
    padding-bottom: 0.52rem;

    &>div {
        background: #ffffff;
        box-shadow: 0px 0px 18px 0px rgba(18, 111, 204, 0.17);
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: .5rem .58rem;
        box-sizing: border-box;

        div {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 45%;
            margin-bottom: .57rem;

            img {
                width: 1.19rem;
                height: 1.19rem;
                margin-bottom: 0.28rem;
            }

            span:nth-child(2) {
                font-size: .28rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #383838;
            }

            .hr {
                width: 1.5rem;
                height: .2rem;
                margin-bottom: 0.15rem;
            }

            span:nth-child(4) {
                font-size: .22rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #383838;
                // line-height: .5rem;
            }
        }
    }
}

.baidu-map-view {
    width: 100%;
    height: 10.42rem;

    .wrapper {
        img {
            width: 2.54rem;
            margin: 0 auto;
            display: block;
        }
    }
}
</style>
